import { cn } from "@/utils/cn";

interface PricingDescriptionProps {
  className?: string;
  description: string;
}

function PricingDescription({ className, description }: PricingDescriptionProps) {
  return <div className={cn("whitespace-pre-line text-18", className)}>{description}</div>;
}

export default PricingDescription;
